import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import moment from "moment";
import LayoutV2 from "containers/LayoutV2";
import { SearchBarDesktop } from "./SearchBarDesktop";
import { SearchBarMobile } from "./SearchBarMobile";
import { TableDanhSach } from "./TableDanhSach";
import KySoAPI from "service/In/KySoAPI";
import { XuatExcelKySo } from "components/CommonComponent/XuatExcel/KySo";

const initialSearch = {
  sSearch: "",
  sLoaiHopDong: "-1",
  tuNgay: "01/01/2001",
  denNgay: "01/01/4000",
  sTrangThai: "-2",
  iPageSize: 10,
  iPageIndex: 1,
};

const initialData = {
  List: [],
  iTotal: 0,
};

export const DanhSachHopDongKySo = () => {
  const [dataSearch, setDataSearch] = useState(initialSearch);
  const [dataDanhSach, setDataDanhSach] = useState(initialData);
  const [selectedIds, setSelectedIds] = useState([]);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [cancelReason, setCancelReason] = useState("");
  const [isCancelling, setIsCancelling] = useState(false);
  const [cancelError, setCancelError] = useState(null);
  const [showExportModal, setShowExportModal] = useState(false);

  useEffect(() => {
    document.title =
      "Danh sách hợp đồng ký số | Phần mềm quản lý cầm đồ Morman";
    onSearch();
  }, []);

  const onSearch = async () => {
    setSelectedIds([]);

    try {
      const res = await KySoAPI.getDanhSachKySo(
        dataSearch.sSearch,
        dataSearch.sLoaiHopDong,
        dataSearch.tuNgay,
        dataSearch.denNgay,
        dataSearch.sTrangThai,
        dataSearch.iPageIndex,
        dataSearch.iPageSize,
      );

      const payload = res && res.data ? res.data : res || {};
      const list = Array.isArray(payload.List)
        ? payload.List
        : Array.isArray(payload.Data)
          ? payload.Data
          : Array.isArray(payload.data)
            ? payload.data
            : Array.isArray(payload)
              ? payload
              : payload &&
                  typeof payload === "object" &&
                  Object.keys(payload).length > 0
                ? [payload]
                : [];
      const total =
        typeof payload.iTotal === "number"
          ? payload.iTotal
          : typeof payload.total === "number"
            ? payload.total
            : typeof payload.Total === "number"
              ? payload.Total
              : list.length;

      setDataDanhSach({
        List: list,
        iTotal: total,
      });
    } catch (error) {
      console.error("Lỗi API danh sách ký số:", error);
      setDataDanhSach({
        List: [],
        iTotal: 0,
      });
    }
  };

  const handleSelectAll = (checked) => {
    if (checked) {
      setSelectedIds(
        dataDanhSach.List.filter((item) => item.TrangThai === 2).map(
          (item) => item.Id,
        ),
      );
    } else {
      setSelectedIds([]);
    }
  };

  const handleSelectOne = (id, checked) => {
    if (checked) {
      setSelectedIds((prev) => [...prev, id]);
    } else {
      setSelectedIds((prev) => prev.filter((item) => item !== id));
    }
  };

  const handleCancelContract = (item) => {
    setSelectedIds([item.Id]);
    setShowCancelModal(true);
  };

  const openCancelModal = () => {
    if (selectedIds.length === 0) return;
    setShowCancelModal(true);
  };

  const handleConfirmCancel = async () => {
    if (!cancelReason.trim()) return;

    setCancelError(null);
    setIsCancelling(true);

    try {
      const res = await KySoAPI.cancelHopDongKySo(
        selectedIds,
        cancelReason.trim(),
      );

      if (!res || !res.ok) {
        const message =
          res?.problem || res?.data?.message || "Lỗi khi hủy hợp đồng";
        throw new Error(message);
      }

      setShowCancelModal(false);
      setCancelReason("");
      setSelectedIds([]);
      await onSearch();
    } catch (error) {
      console.error("Lỗi hủy hợp đồng:", error);
      setCancelError(error?.message || "Hủy hợp đồng không thành công.");
    } finally {
      setIsCancelling(false);
    }
  };

  const handleExportExcel = () => {
    // TODO: Kết nối chức năng xuất Excel
    console.log("Xuất Excel danh sách");
  };

  const handleShowContractDetail = (item) => {
    // TODO: Hiển thị popup chi tiết hợp đồng
    console.log("Chi tiết hợp đồng", item);
  };

  const handlePrintContract = async (item) => {
    try {
      const id = item.Id || item.id || item.KySoId;

      if (!id) {
        console.error("Không tìm thấy Id hợp đồng ký số để in", item);
        return;
      }

      const response = await KySoAPI.getKySoInPdf(id);
      if (!response || !response.blob) {
        throw new Error("Không nhận được file in hợp đồng");
      }

      const filename =
        getFileNameFromContentDisposition(response.headers) ||
        `HopDongKySo_${moment().format("YYYYMMDDHHmmss")}.pdf`;

      const url = window.URL.createObjectURL(response.blob);
      const downloadLink = document.createElement("a");
      downloadLink.href = url;
      downloadLink.setAttribute("download", filename);
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Lỗi in hợp đồng ký số:", error);
    }
  };

  const getFileNameFromContentDisposition = (headers) => {
    if (!headers) return null;

    const contentDisposition =
      headers["content-disposition"] || headers["Content-Disposition"] || "";
    const fileNameMatch =
      /filename\*=UTF-8''([^;\n\r]+)|filename="?([^";\n\r]+)"?/.exec(
        contentDisposition,
      );
    return fileNameMatch
      ? decodeURIComponent(fileNameMatch[1] || fileNameMatch[2])
      : null;
  };

  const handleShowCustomerInfo = (item) => {
    // TODO: Hiển thị popup thông tin cá nhân khách hàng
    console.log("Thông tin khách hàng", item);
  };

  return (
    <LayoutV2>
      <div id="form-repeater">
        <div className="sticky-moman-bh">
          <div className="col-12">
            <div className="camdo-home">
              <div className="breadcrumb-new hidden-mobile-main show-table-main">
                <div className="row">
                  <div className="col-sm-12 col-md-12 title-cd">
                    <div className="media-home align-center-home">
                      <div className="row header">
                        <img
                          className="icon-bred-home"
                          src="/app-assets/images/logo-tragop-v2.png"
                          alt=""
                        />
                        <h1 className="text-info-home">
                          Danh sách hợp đồng ký số
                        </h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card border-light mb-1 hidden-mobile-main show-table-main card-v2">
              <div className="card-body card-body-v2">
                <SearchBarDesktop
                  dataSearch={dataSearch}
                  setDataSearch={setDataSearch}
                  onSearch={onSearch}
                />
              </div>
            </div>
            {/* <SearchBarMobile
              dataSearch={dataSearch}
              setDataSearch={setDataSearch}
              onSearch={onSearch}
            /> */}
          </div>
        </div>
        <div
          className="card border-light mb-3 card-v2"
          style={{ marginLeft: "15px", marginRight: "15px" }}
        >
          <div className="card-body card-body-v2 d-flex flex-wrap align-items-center justify-content-between">
            <div className="d-flex flex-wrap">
              <button
                className="btn btn-danger mb-2"
                style={{ height: "40px" }}
                type="button"
                onClick={openCancelModal}
                disabled={selectedIds.length === 0}
              >
                Hủy hợp đồng
              </button>
              <button
                className="btn ml-2 btn-info-new"
                type="button"
                onClick={() => setShowExportModal(true)}
              >
                Xuất Excel
              </button>
            </div>
          </div>
          <TableDanhSach
            dataDanhSach={dataDanhSach}
            dataSearch={dataSearch}
            setDataSearch={setDataSearch}
            onSearch={onSearch}
            selectedIds={selectedIds}
            onSelectAll={handleSelectAll}
            onSelectOne={handleSelectOne}
            onShowContractDetail={handleShowContractDetail}
            onShowCustomerInfo={handleShowCustomerInfo}
            onPrintContract={handlePrintContract}
            onCancelContract={handleCancelContract}
          />
        </div>
      </div>
      <XuatExcelKySo
        dataSearch={dataSearch}
        show={showExportModal}
        onHide={() => setShowExportModal(false)}
      />
      <Modal
        show={showCancelModal}
        onHide={() => setShowCancelModal(false)}
        backdrop="static"
        centered
        className="modal-new modal fade text-left"
      >
        <Modal.Header>
          <h4 className="modal-title" id="myModalLabel16">
            <span className="btn-icon-right">
              <i className="mdi mdi-delete"></i>
            </span>
            Hủy hợp đồng ký số
          </h4>
          <button
            type="button"
            className="close-popup-new"
            onClick={(e) => setShowCancelModal(false)}
          >
            <i className="mdi mdi-close"></i>
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="form-group">
            <label>Lý do hủy</label>
            <textarea
              className="form-control"
              rows={4}
              value={cancelReason}
              onChange={(e) => setCancelReason(e.target.value)}
              placeholder="Nhập lý do hủy hợp đồng"
            />
          </div>
          {cancelError && (
            <div className="alert alert-danger" role="alert">
              {cancelError}
            </div>
          )}
          <div className="alert alert-info" role="alert">
            Số hợp đồng cần hủy: {selectedIds.length}
          </div>
        </Modal.Body>
        {/* <Modal.Footer>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setShowCancelModal(false)}
            disabled={isCancelling}
          >
            Đóng
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={handleConfirmCancel}
            disabled={isCancelling || !cancelReason.trim()}
          >
            {isCancelling ? "Đang hủy..." : "Xác nhận hủy"}
          </button>
        </Modal.Footer> */}
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-new-main btn-closenew"
            onClick={() => setShowCancelModal(false)}
            disabled={isCancelling}
          >
            <span className="btn-icon-left">
              <i className="mdi mdi-close"></i>
            </span>
            Đóng
          </button>

          <button
            type="button"
            className="btn btn-new-main btn-checknew"
            onClick={handleConfirmCancel}
            disabled={isCancelling || !cancelReason.trim()}
          >
            <span className="btn-icon-left">
              <i className="mdi mdi-check"></i>
            </span>
            Xác nhận
          </button>
        </Modal.Footer>
      </Modal>{" "}
    </LayoutV2>
  );
};
